import { FormContentIsland, Grid } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { AccountAutocomplete } from '../../Autocomplete/AccountAutocomplete';
import { Route } from '../../../routes/account.topup';
import { useCallback, useLayoutEffect } from 'react';
import { AccountRequisitesIsland } from '../../Account/AccountRequisitesIsland';
import { useAccountsWithAccountQuery } from '../../../api/accounts';

export function TopUpPage() {
  const { t } = useTranslation();
  const navigate = Route.useNavigate();
  const { accountId } = Route.useSearch();
  const accountsQuery = useAccountsWithAccountQuery(accountId);

  const defaultAccountId = accountsQuery.data?.[0]?.id ?? undefined;
  const handleAccountChange = useCallback(
    (_: unknown, nextAccountId: string | null) => {
      navigate({ search: { accountId: nextAccountId ?? defaultAccountId } });
    },
    [navigate, defaultAccountId],
  );

  useLayoutEffect(() => {
    if (!accountId && defaultAccountId) {
      navigate({
        search: (prev) => (prev.accountId ? prev : { accountId: defaultAccountId }),
        replace: true,
      });
    }
  }, [accountId, defaultAccountId, navigate]);

  if (!accountId && defaultAccountId) {
    // avoid flickering of account change when switching between pages
    return null;
  }

  return (
    <MainLayout title={t('Top up')} compact>
      <Grid size={12}>
        <FormContentIsland>
          <AccountAutocomplete
            label={t('Account')}
            loading={accountsQuery.isPending}
            accounts={accountsQuery.data}
            value={accountId}
            onChange={handleAccountChange}
            fullWidth
            disableClearable
          />
        </FormContentIsland>
      </Grid>
      <Grid size={12}>{accountId ? <AccountRequisitesIsland accountId={accountId} /> : null}</Grid>
    </MainLayout>
  );
}
